/*
 * The email a sign-up is verifying, kept for this tab only so a refresh on
 * /verify doesn't drop the person back on the account step. Never the
 * password: after a refresh /verify asks for it again.
 */

const KEY = 'dodil_signup_email';

export function rememberSignupEmail(email: string): void {
    try { sessionStorage.setItem(KEY, email); } catch { /* not kept: a refresh starts over */ }
}

export function signupEmail(): string | undefined {
    try { return sessionStorage.getItem(KEY) || undefined; } catch { return undefined; }
}

export function forgetSignupEmail(): void {
    try { sessionStorage.removeItem(KEY); } catch { /* nothing kept */ }
}
